import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full relative max-h-[90vh] overflow-y-auto" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center items-center min-h-[400px]"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col gap-6"
}
const _hoisted_4 = {
  key: 0,
  class: "border-t border-gray-200 my-0"
}
const _hoisted_5 = {
  key: 1,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_7 = { class: "max-h-[350px] overflow-y-auto" }
const _hoisted_8 = { class: "overflow-x-auto mr-8" }
const _hoisted_9 = { class: "w-full min-w-[700px] border border-gray-200 mb-4 mx-auto" }
const _hoisted_10 = {
  class: "py-2 text-sm text-gray-900 text-left pl-4 font-semibold",
  colspan: "4"
}
const _hoisted_11 = { class: "py-2 text-sm text-gray-900 text-left pl-4" }
const _hoisted_12 = { class: "py-2 text-right text-sm text-gray-900 pl-2 w-20" }
const _hoisted_13 = { class: "py-2 text-right text-sm text-gray-900 px-0 w-28" }
const _hoisted_14 = { class: "py-2 text-right text-sm text-gray-900 px-0 w-28" }
const _hoisted_15 = { class: "w-full max-w-3xl mx-auto mt-4" }
const _hoisted_16 = { class: "w-fit ml-auto text-sm" }
const _hoisted_17 = { class: "text-gray-900 text-left py-1" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-gray-700 text-right pr-8 py-1 whitespace-nowrap" }
const _hoisted_20 = { class: "text-green-700 text-left py-1" }
const _hoisted_21 = { class: "text-gray-900 text-left py-1" }
const _hoisted_22 = { class: "text-gray-900 text-left py-1" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "text-gray-900 text-left py-1" }
const _hoisted_26 = { class: "text-gray-900 text-left py-1" }
const _hoisted_27 = { class: "text-gray-900 text-left py-1 font-semibold" }
const _hoisted_28 = { class: "flex flex-col gap-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrentPaymentMethodModal = _resolveComponent("CurrentPaymentMethodModal")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 bg-black bg-opacity-50 px-6 flex items-center justify-center z-50",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "absolute top-2 right-2 text-gray-500 hover:text-gray-700",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, " ✕ "),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary-purple mb-6" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex flex-col items-center" }, [
                  _createElementVNode("span", { class: "text-xl font-bold text-gray-900" }, "Subscription Details")
                ], -1)),
                (_ctx.upcomingInvoice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                  : _createCommentVNode("", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[4] || (_cache[4] = [
                      _createElementVNode("div", { class: "animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary-purple" }, null, -1)
                    ])))
                  : _createCommentVNode("", true),
                (_ctx.upcomingInvoice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-lg font-semibold text-gray-900 text-left mb-4" }, "Upcoming Invoice", -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("table", _hoisted_9, [
                              _cache[5] || (_cache[5] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "pl-4 py-2 text-left text-xs font-semibold text-gray-500" }, " Description "),
                                  _createElementVNode("th", { class: "pl-2 py-2 text-right text-xs font-semibold text-gray-500 w-20" }, " Qty "),
                                  _createElementVNode("th", { class: "px-0 py-2 text-right text-xs font-semibold text-gray-500 w-28" }, " Unit price "),
                                  _createElementVNode("th", { class: "px-0 py-2 text-right text-xs font-semibold text-gray-500 w-28" }, " Amount ")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedLineItems, (items, period) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: period }, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_10, _toDisplayString(period), 1)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item, idx) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                        _createElementVNode("td", _hoisted_11, _toDisplayString(item.description), 1),
                                        _createElementVNode("td", _hoisted_12, _toDisplayString(item.qty), 1),
                                        _createElementVNode("td", _hoisted_13, " $" + _toDisplayString(item.unitPrice.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1),
                                        _createElementVNode("td", _hoisted_14, " $" + _toDisplayString(item.amount.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1)
                                      ]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("table", _hoisted_16, [
                              _cache[12] || (_cache[12] = _createElementVNode("thead", { class: "sr-only" }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "Label"),
                                  _createElementVNode("th", null, "Amount")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-gray-700 text-right pr-8 py-1 whitespace-nowrap" }, " Subtotal ", -1)),
                                  _createElementVNode("td", _hoisted_17, " $" + _toDisplayString(_ctx.upcomingInvoice.subtotal.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })), 1)
                                ]),
                                (
                        _ctx.upcomingInvoice.discounts &&
                        _ctx.upcomingInvoice.discounts.length
                      )
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.upcomingInvoice.discounts[0].label), 1),
                                      _createElementVNode("td", _hoisted_20, " -$" + _toDisplayString(_ctx.upcomingInvoice.discounts[0].amount.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("tr", null, [
                                  _cache[7] || (_cache[7] = _createElementVNode("td", { class: "text-gray-700 text-right pr-8 py-1 whitespace-nowrap" }, " Total excluding tax ", -1)),
                                  _createElementVNode("td", _hoisted_21, " $" + _toDisplayString(_ctx.upcomingInvoice.totalExcludingTax.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _cache[8] || (_cache[8] = _createElementVNode("td", { class: "text-gray-700 text-right pr-8 py-1 whitespace-nowrap" }, " Tax ", -1)),
                                  _createElementVNode("td", _hoisted_22, [
                                    (
                            !_ctx.upcomingInvoice.tax || _ctx.upcomingInvoice.tax === 0
                          )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_24, " $" + _toDisplayString(_ctx.upcomingInvoice.tax.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _cache[9] || (_cache[9] = _createElementVNode("td", { class: "text-gray-900 text-right pr-8 py-1 whitespace-nowrap" }, " Total ", -1)),
                                  _createElementVNode("td", _hoisted_25, " $" + _toDisplayString(_ctx.upcomingInvoice.total.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _cache[10] || (_cache[10] = _createElementVNode("td", { class: "text-gray-900 text-right pr-8 py-1 whitespace-nowrap" }, " Applied Balance ", -1)),
                                  _createElementVNode("td", _hoisted_26, " $" + _toDisplayString(_ctx.upcomingInvoice.appliedBalance.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _cache[11] || (_cache[11] = _createElementVNode("td", { class: "text-gray-900 text-right pr-8 py-1 whitespace-nowrap font-semibold" }, " Amount due ", -1)),
                                  _createElementVNode("td", _hoisted_27, " $" + _toDisplayString(_ctx.upcomingInvoice.amountDue.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "border-t border-gray-200 my-1" }, null, -1)),
                _createVNode(_component_CurrentPaymentMethodModal, {
                  source: _ctx.source,
                  cardNumber: _ctx.cardNumber,
                  cardExpiry: _ctx.cardExpiry,
                  invoiceRecipientEmail: _ctx.invoiceRecipientEmail
                }, null, 8, ["source", "cardNumber", "cardExpiry", "invoiceRecipientEmail"]),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "border-t border-gray-200 my-0" }, null, -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_BaseButton, {
                    type: "button",
                    class: "flex flex-col justify-center items-center p-2 w-full text-white bg-primary-purple rounded-lg text-sm font-medium leading-none text-center",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('proceed')))
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createElementVNode("span", null, "Proceed", -1)
                    ])),
                    _: 1
                  }),
                  (_ctx.showBillingButton)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 0,
                        type: "button",
                        class: "flex flex-col justify-center items-center p-2 w-full text-primary-purple bg-violet-100 rounded-lg text-sm font-medium leading-none text-center",
                        onClick: _ctx.goToBilling
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createElementVNode("span", null, "Change Payment Method in Billing", -1)
                        ])),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}